import { useFirebaseData } from './useFirebaseData';

/**
 * Custom hook to manage store data from Firebase
 * Returns all store data including products, categories, hero slides, testimonials, etc.
 */
export const useStoreData = () => {
  return useFirebaseData();
};

/**
 * Helper function to check if product has size available
 */
export const isSizeAvailable = (product, size) => {
  const sizeInfo = product.sizes?.find(s => s.size === size);
  return sizeInfo ? sizeInfo.available : false;
};

/**
 * Helper function to get available sizes for a product
 */
export const getAvailableSizes = (product) => {
  return product.sizes?.filter(s => s.available).map(s => s.size) || [];
};

/**
 * Helper function to get main product image (first image in array)
 */
export const getMainImage = (product) => {
  return product.images && product.images.length > 0 ? product.images[0] : '';
};
